import React from 'react';

const ExecutionContext = React.createContext(null);

export default ExecutionContext;
